import styled from 'styled-components'
import PropTypes from 'prop-types'

import { Icon } from '@mch-group/uikit-components'
import { px2rem } from '@utils'
import tokens from '@mch-group/design-tokens/build/js/design_tokens-module'

const ButtonWithCloseIcon = ({ onClick, label }) => (
  <ButtonStyled
    className='label label-3 color-black'
    onClick={onClick}
    type='button'
  >
    <Icon name='close' /> {label}
  </ButtonStyled>
)

const ButtonStyled = styled.button`
  cursor: pointer;
  border: none;
  background: none;
  font-weight: ${tokens.fontWeights.artBaselHeadline0.value} !important;
  text-decoration: underline;
  padding: 0;

  svg {
    fill: var(--bs-mch-black);
    margin-right: ${px2rem(3)};
  }
`

ButtonWithCloseIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string
}

export default ButtonWithCloseIcon
